<template>
  <div>
    <!--------Contact section end-------->
    <div id="contact" class="page stellar">
      <div class="pageheader">
        <div class="headercontent">
          <div class="section-container">
            <h2 class="title">Contact & Meet Me</h2>
            <div class="row">
              <div class="col-md-8">
                <p>I would be happy to talk to you if you need my assistance in your research.
                  .....</p>
              </div>
              <div class="col-md-4">
                <ul class="list-unstyled">
                  <li>
                    <strong><i class="icon-phone"></i>&nbsp;&nbsp;</strong>
                    <span>office: +8801521482467</span>
                  </li>
                  <li>
                    <strong><i class="icon-phone"></i>&nbsp;&nbsp;</strong>
                    <span>lab: +8801521482467</span>
                  </li>
                  <li>
                    <strong><i class="icon-envelope"></i>&nbsp;&nbsp;</strong>
                    <span><a href="mailto:karim.cse007@gmail.com" class="__cf_email__" data-cfemail="">karim.cse007@gmail.com </a></span>
                  </li>
                  <li>
                    <strong><i class="icon-skype"></i>&nbsp;&nbsp;</strong>
                    <span>ab.karim007</span>
                  </li>
                  <li>
                    <strong><i class="icon-facebook"></i>&nbsp;&nbsp;</strong>
                    <a href="http://facebook.com/ab.karim007" target="_blank"><span>Md Abdul Karim</span></a>
                  </li>
                  <li>
                    <strong><i class="icon-twitter"></i>&nbsp;&nbsp;</strong>
                    <a href="https://twitter.com/abkarim007" target="_blank"><span>@abkarim007</span></a>

                  </li>
                  <li>
                    <strong><i class="icon-linkedin-sign"></i>&nbsp;&nbsp;</strong>
                    <span>
                      <a :href="'https://www.linkedin.com/in/md-abdul-karim-371190190/'" target="_blank">md-abdul-karim-371190190</a>
                  </span>
                  </li>
                </ul>

              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="pagecontents">
        <div class="section contact-office" data-stellar-background-ratio="0.1">
          <div class="section-container">
            <div class="row">
              <div class="col-md-8">
                <h2 class="title">At My Office</h2>
                <p>You can find me at my office located at StylZmedia LTD, Dhaka, Bangladesh</p>
                <p>I am at my office every Sunday-Thursday from 10:00 am until 5:00 pm, but i am currently working form home.</p>
              </div>
              <div class="col-md-4 text-center hidden-xs hidden-sm">
                <i class="icon-coffee icon-huge"></i>
              </div>

            </div>
          </div>
        </div>

<!--        <div class="section color-1">
          <div class="section-container">
            <div class="row">
              <div class="col-md-4 text-center hidden-xs hidden-sm">
                <i class="icon-stethoscope icon-huge"></i>
              </div>
              <div class="col-md-8">
                <h2 class="title">At My Work</h2>
                <p>You can find me at my Work located at United IT Solution LTD, Dhaka, Bangladesh</p>
                <p>I am at my office every day from 10:00 am until 5:00 pm, but you may consider a call to fix an
                  appointment.</p>
              </div>
            </div>
          </div>
        </div>
        <div class="section contact-lab" data-stellar-background-ratio="0.1">
          <div class="section-container">
            <div class="row">

              <div class="col-md-8">
                <h2 class="title">At My Lab</h2>
                <p>You can find me at my office located at United IT Solution LTD, Dhaka, Bangladesh</p>
                <p>I am at my office every day from 10:00 am until 5:00 pm, but you may consider a call to fix an
                  appointment.</p>
              </div>
              <div class="col-md-4 text-center hidden-xs hidden-sm">
                <i class="icon-superscript icon-huge"></i>
              </div>

            </div>
          </div>
        </div>
        -->
      </div>
    </div>
    <div id="overlay"></div>
    <!--------Contact section end-------->
  </div>

</template>
<script>
export default {
  name: 'Contact',
}
</script>